import { post } from './shared';

export function athleteOptIn() {
  return post('publisher/athlete/opt-in');
}

export function athleteDismiss() {
  return post('publisher/athlete/dismiss');
}
